import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ServicoLogisticaReversaItem } from '../../../../../../shared/services/models/vendas/forma-envio-detalhe.model';

export interface ServicoReversaDialogData {
  item: ServicoLogisticaReversaItem | null;
}

@Component({
  selector: 'app-servico-reversa-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './servico-reversa-dialog.component.html',
  styleUrl: './servico-reversa-dialog.component.css',
})
export class ServicoReversaDialogComponent implements OnInit {
  public form: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ServicoReversaDialogComponent, ServicoLogisticaReversaItem | null>,
    @Inject(MAT_DIALOG_DATA) public data: ServicoReversaDialogData
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      descricao: [this.data.item?.descricao ?? '', Validators.required],
      codigoServico: [this.data.item?.codigoServico ?? null],
    });
  }

  public confirmar(): void {
    if (this.form.invalid) return;
    const result: ServicoLogisticaReversaItem = {
      idServicoLogisticaReversa: this.data.item?.idServicoLogisticaReversa ?? 0,
      descricao: this.form.value.descricao,
      codigoServico: this.form.value.codigoServico || null,
    };
    this.dialogRef.close(result);
  }

  public cancelar(): void {
    this.dialogRef.close(null);
  }
}
